import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core'
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { CustomerService } from 'src/app/core/services/customer.service'
import { CustomerListItem } from 'src/app/shared/interfaces/customer/customer-list-item.interface'
import { Observable } from 'rxjs'
import { RecentlyViewed } from 'src/app/shared/interfaces/shared/recently-viewed.interface'
import { CustomerDetailComponent } from '../customer-detail/customer-detail.component'
import { EmptyComponent } from '../../empty/empty.component'
import { DateagoPipe } from 'src/app/shared/pipes/dateago.pipe'
import { RouterLink } from '@angular/router'

@Component({
    selector: 'sf-recent-customers-pullout',
    imports: [RouterLink, ButtonComponent, CustomerDetailComponent, EmptyComponent, DateagoPipe, AsyncPipe],
    templateUrl: './recent-customers-pullout.component.html',
    styleUrl: './recent-customers-pullout.component.scss',
})
export class RecentCustomersPulloutComponent implements OnInit {
    activeOffcanvas = inject(NgbActiveOffcanvas)
    #customerService = inject(CustomerService)

    recentCustomers$!: Observable<RecentlyViewed<CustomerListItem>[]>

    ngOnInit(): void {
        this.recentCustomers$ = this.#customerService.getRecentlyViewedCustomers()
    }

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }
    close(): void {
        this.activeOffcanvas.close()
    }
}
